var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"masthead"}},[_c('v-img',{attrs:{"src":require("@/assets/site-images/fantasy-art-masthead.jpg")}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }